import { PenaltyType } from "../models/enum/penaltyType";
import { useMutation } from "@tanstack/react-query";
import { Response } from "../models/response";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import { WinnerIdInfo } from "../models/winnerIdInfo";

interface UsePenaltyProps {
  artistId?: number;
  eventId?: number;
  rewardId?: number;
}

export function usePenalty({ artistId, eventId, rewardId }: UsePenaltyProps) {
  const { mutateAsync: penalize, isPending } = useMutation({
    mutationFn: async ({
      type,
      isCancel,
      violationId,
      userIds,
    }: {
      type: PenaltyType;
      isCancel: boolean;
      violationId?: number;
      userIds?: WinnerIdInfo;
    }) => {
      if (artistId && eventId && rewardId) {
        return new Response(
          isCancel
            ? await HttpClient.request(
                OnSiteApi.cancelPenalty(
                  artistId,
                  eventId,
                  rewardId,
                  type,
                  violationId!,
                ),
              )
            : await HttpClient.request(
                OnSiteApi.penalize(
                  artistId,
                  eventId,
                  rewardId,
                  type,
                  userIds!.fanId,
                  userIds!.winnerId,
                ),
              ),
        );
      }
      return null;
    },
  });

  return { penalize, isPending };
}
